import { render, staticRenderFns } from "./m-work-order-show.html?vue&type=template&id=a821e880&scoped=true&"
import script from "./m-work-order-show.ts?vue&type=script&lang=js&"
export * from "./m-work-order-show.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821e880",
  null
  
)

export default component.exports